import { render, staticRenderFns } from "./CustomerOTP.vue?vue&type=template&id=0d8bf494&scoped=true&"
import script from "./CustomerOTP.vue?vue&type=script&lang=ts&"
export * from "./CustomerOTP.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOTP.vue?vue&type=style&index=0&id=0d8bf494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8bf494",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VOtpInput,VOverlay,VProgressCircular,VRow,VSnackbar})
